module.exports = __webpack_public_path__ + "img/img3.beb5af1b.jpg";